import { Image } from "primereact/image";

import { SuggestionCard } from "./SuggestionCard";
import {
  buttonAnnul,
  buttonSelect,
  formSendMessage,
  labelArgsWithExample,
  labelChatEmptyFirstRow,
  labelChatEmptySecondRow,
  labelCopyRightChat,
  labelExtendedChat,
  labelExtendedContents,
  labelNewQuiz,
  labelNewSummary,
  labelNoResults,
  labelReduceChat,
  labelResults,
  labelSaveRes,
  labelSchematize,
  labelAnswerTypeArticolo,
} from "_constants";
import notFoundProject from "../../../../../assets/images/not_found_project.svg";
import icon_quiz from "assets/icons/icon_quiz.svg";
import icon_args_exp from "assets/icons/icon_args_exp.svg";
import icon_summary from "assets/icons/icon_summary.svg";
import icon_schematize from "assets/icons/icon_schematize.svg";
import icon_articolo from "assets/icons/icon_articolo.svg";
import icon_ext_contents from "assets/icons/icon_ext_contents.svg";
import icon_expanded_chat from "assets/icons/icon_expanded_chat.svg";
import icon_reduce_chat from "assets/icons/icon_reduce_chat.svg";
import { InputSearchResponseChat } from "./InputSearchResponseChat";
import { Button } from "primereact/button";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  resetCheckIds,
  resetCurrentAnswer,
  setSaveAnswers,
  setSelect,
} from "store/slicer/GestioneSaveAnswerSlice";
import { getChatHistory, getPinnedAnswers, sendMessage } from "services";
import { SaveResponseCard } from "./saveResponseCard/SaveResponseCard";
import { InputTextMessage } from "./InputTextMessage/InputTextMessage";
import { ActionsSaveResponseCard } from "./ActionsSaveResponseCard";
import { useForm } from "react-hook-form";
import {
  addMessage,
  setAnswer,
  setChatHistory,
  setErrorMessage,
  setLoadingChatHistory,
  setNewMessage,
  setOpenChat,
  setProjectId,
  setRepliedAnswer,
  setWaitMessage,
} from "store/slicer/GestioneChatSlice";
import { ChatHistoryPage } from "./ChatHistoryPage";
import { getNamePaddBySuggestionCardIndex } from "utils";

export const ChatPage = ({ projectId }: { projectId: string }) => {
  const [ChatHistoryPageHeight, setChatHistoryPageHeight] = useState(
    "calc(100dvh - 281px)"
  );
  const [inputTextMessageHeight, setInputTextMessageHeight] = useState(0);
  const dispatch = useAppDispatch();
  const [openedChatFirstTime, setOpenedChatFirstTime] = useState(true);
  const [activeAnswerType, setActiveAnswerType] = useState<number | null>(null);
  const savedAnswers = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.saveAnswers
  );
  const savedAnswersFiltered = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.saveAnswersFiltered
  );
  const selectButton = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.select
  );
  const loaded = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.loaded
  );
  const projectList = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.listSourceProjectFiltered
  );
  const count = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.count
  );
  const filters = useAppSelector((state) => state.gestioneChatSlice.filters);
  const openChat = useAppSelector((state) => state.gestioneChatSlice.openChat);
  const repliedAnswer = useAppSelector(
    (state) => state.gestioneChatSlice.repliedAnswer
  );
  const loadedChatHistory = useAppSelector(
    (state) => state.gestioneChatSlice.loading
  );
  const items = [
    {
      icon: icon_quiz,
      name: labelNewQuiz,
      answerType: 1,
    },
    {
      icon: icon_summary,
      name: labelNewSummary,
      answerType: 2,
    },
    {
      icon: icon_schematize,
      name: labelSchematize,
      answerType: 3,
    },
    {
      icon: icon_ext_contents,
      name: labelExtendedContents,
      answerType: 4,
    },
    {
      icon: icon_args_exp,
      name: labelArgsWithExample,
      answerType: 5,
    },
    {
      icon: icon_articolo,
      name: labelAnswerTypeArticolo,
      answerType: 6,
    },
  ];

  const changeSelectButton = () => {
    if (selectButton) {
      dispatch(resetCheckIds());
    }
    dispatch(setSelect(!selectButton));
  };

  useEffect(() => {
    if (filters.projectId && !loadedChatHistory) {
      getChatHistory(filters)
        .then((res) => {
          res.data.items.reverse();
          dispatch(setChatHistory(res.data));
          dispatch(setLoadingChatHistory(true));
        })
        .catch((_) => {});
    }
  }, [dispatch, filters, loadedChatHistory]);

  useEffect(() => {
    if (projectId) {
      dispatch(setProjectId(projectId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useEffect(() => {
    if (projectId && !loaded) {
      getPinnedAnswers(projectId)
        .then((response) => {
          dispatch(setSaveAnswers(response.data.savedAnswers));
        })
        .catch((_) => {});
    }
  }, [dispatch, loaded, projectId]);

  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      projectId: "",
      message: "",
      toneOfVoice: 0,
      answerType: 0,
      codex: [] as any[],
      archive: [] as any[],
      private: [] as any[],
      repliedAnswer: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  const toggleChat = () => {
    if (openChat) {
      resetFormState();
      dispatch(setRepliedAnswer(""));
      dispatch(resetCurrentAnswer());
    }
    setOpenedChatFirstTime(false);
    dispatch(setOpenChat(!openChat));
  };

  const setValueChat = useCallback(() => {
    setValue("projectId", projectId);

    setValue(
      "private",
      projectList.privateSourcesList
        .filter((source) => source.isChecked)
        .map((source) => source.id)
    );
    setValue(
      "codex",
      projectList.codesList
        .filter((sourceCode) => sourceCode.isChecked)
        .map((sourceCode) => sourceCode.id)
    );
    setValue(
      "archive",
      projectList.sourcesList
        .filter((sourceArchive) => sourceArchive.isChecked)
        .map((sourceArchive) => sourceArchive.id)
    );
  }, [
    projectId,
    projectList.codesList,
    projectList.privateSourcesList,
    projectList.sourcesList,
    setValue,
  ]);

  useEffect(() => {
    setValueChat();
  }, [setValueChat]);

  useEffect(() => {
    setValue("repliedAnswer", repliedAnswer);
    calculateChatHistoryPageHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repliedAnswer, setValue]);

  useEffect(() => {
    if (!count) {
      resetFormState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  const onSubmit = (formData: any) => {
    dispatch(resetCurrentAnswer());
    dispatch(setWaitMessage(true));
    setOpenedChatFirstTime(true);
    dispatch(setOpenChat(true));
    dispatch(
      addMessage({
        message: formData.message,
        answerType: formData.answerType,
        repliedAnswer: formData.repliedAnswer,
        answersList: [],
      })
    );
    resetFormState();
    dispatch(setRepliedAnswer(""));
    setOpenedChatFirstTime(true);
    dispatch(setErrorMessage(false));
    sendMessage(formData)
      .then((res) => {
        dispatch(setAnswer(res.data));
        dispatch(setNewMessage(true));
      })
      .catch((_) => {
        dispatch(setErrorMessage(true));
      })
      .finally(() => {
        dispatch(setWaitMessage(false));
      });
  };

  const resetFormState = () => {
    control._reset();
    setValueChat();
    setActiveAnswerType(null);
  };

  const calculateChatHistoryPageHeight = (height?: number) => {
    const newHeight =
      281 +
      (repliedAnswer?.length ? 80 : 0) +
      (repliedAnswer?.length
        ? (height ?? inputTextMessageHeight) > 130
          ? 12
          : 0
        : (height ?? inputTextMessageHeight) > 61
        ? 20
        : 0);
    setChatHistoryPageHeight(`calc(100dvh - ${newHeight}px)`);
  };

  const onHeightChange = (height: any) => {
    setInputTextMessageHeight(height);
    calculateChatHistoryPageHeight(height);
  };

  return (
    <div
      className={`container-chat width-100 relative ${
        openChat ? "bg-white" : ""
      }`}
    >
      <div
        className={`${
          openedChatFirstTime ? "hide" : openChat ? "opacityOut" : "opacityIn"
        } container-body-chat`}
      >
        <div className="padd-18 width-100">
          <div className="flex-container width-100 justify-between pinned-answers-header-container">
            <div>
              <h4 className="text-title">{labelSaveRes}</h4>{" "}
              <span className="text-base-regular">
                {`${savedAnswersFiltered.length} ${labelResults.toLowerCase()}`}
              </span>
            </div>
            <div className="flex-container gap-8">
              <InputSearchResponseChat />
              <Button
                label={selectButton ? buttonAnnul : buttonSelect}
                className="button-select-search-response-disabled"
                onClick={changeSelectButton}
                severity="secondary"
                type="button"
                outlined={!selectButton}
                disabled={!savedAnswersFiltered.length}
              />
            </div>
          </div>
        </div>

        {savedAnswersFiltered.length ? (
          <div
            className={`container-answers gap-12 padd-18 padd-top-0 ${
              selectButton ? "change-height" : ""
            } ${openChat ? "d-none" : ""}`}
          >
            {savedAnswersFiltered.map((answer: any, index: number) => (
              <SaveResponseCard
                key={index}
                answer={answer}
                projectId={projectId}
              />
            ))}
          </div>
        ) : (
          <div className="flex-container align-center justify-center column margin-bottom-46">
            <Image src={notFoundProject} />
            <p className="empty-cards">
              {savedAnswers?.length ? labelNoResults : labelChatEmptyFirstRow}
            </p>
            {!savedAnswers?.length && (
              <p className="empty-cards">{labelChatEmptySecondRow}</p>
            )}
          </div>
        )}
      </div>

      {!selectButton && (
        <ChatHistoryPage
          projectId={projectId}
          showChat={openChat}
          openedChatFirstTime={openedChatFirstTime}
          chatHistoryPageHeight={ChatHistoryPageHeight}
        />
      )}
      <div className="container-input-message relative width-100">
        {!selectButton && (
          <form id={formSendMessage} onSubmit={handleSubmit(onSubmit)}>
            <div className="flex-container justify-between align-center">
              <div className="flex-container gap-6 suggestion-card-container">
                {items.map((item, index) => (
                  <SuggestionCard
                    key={index}
                    icon={item.icon}
                    name={item.name}
                    index={index}
                    isActive={activeAnswerType === item.answerType}
                    callback={() => {
                      if (activeAnswerType === item.answerType) {
                        setValue("answerType", 0);
                        setActiveAnswerType(null);
                      } else {
                        setValue("answerType", item.answerType);
                        setActiveAnswerType(item.answerType);
                      }
                    }}
                  />
                ))}
              </div>
              <Button
                className="flex-container gap-7 box-shadow-none icon-blue"
                text
                icon={
                  <Image
                    src={openChat ? icon_reduce_chat : icon_expanded_chat}
                  />
                }
                label={openChat ? labelReduceChat : labelExtendedChat}
                onClick={toggleChat}
                type="button"
              />
            </div>
            <InputTextMessage
              control={control}
              setValue={setValue}
              onHeightChange={onHeightChange}
              answerType={getNamePaddBySuggestionCardIndex(
                getValues("answerType")
              )}
              onSubmit={handleSubmit(onSubmit)}
            />
            <div className="text-center width-100 margin-top-12 margin-bottom-12">
              <span className="text-sm">{labelCopyRightChat}</span>
            </div>
          </form>
        )}
        {selectButton && <ActionsSaveResponseCard projectId={projectId} />}
      </div>
    </div>
  );
};
